export function formatMeasurementReminderDurationLabel({
  estimatedDurationMinutes,
  minutesShortLabel,
}: {
  estimatedDurationMinutes?: number | null
  minutesShortLabel: string
}): string | null {
  if (
    estimatedDurationMinutes == null ||
    !Number.isFinite(estimatedDurationMinutes) ||
    estimatedDurationMinutes <= 0
  ) {
    return null
  }

  return `${Math.ceil(estimatedDurationMinutes)} ${minutesShortLabel}`
}
